import React from 'react';

import UserService from '../../services/user';
import PostService from '../../services/post';
import PreferenceService from '../../services/preference';

import Navigation from '../../components/navigation';
import Footer from '../../components/footer';
import LoadingIndicator from '../../components/loading-indicator';
import ResponsiveNavigation from '../../components/responsive-navigation';
import HelmetComponent from '../../components/helmet';
import PostList from '../../components/post-list';

class Feed extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            posts: [],
            isLoading: true,
        };

        this.fetchFeed = this.fetchFeed.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        PreferenceService.subscribe('explicitFilterStateChange', this.handleFilterChange);
        this.fetchFeed();
    }

    componentWillUnmount() {
        PreferenceService.unsubscribe('explicitFilterStateChange', this.handleFilterChange);
    }

    handleFilterChange() {
        this.setState({ isLoading: true, posts: [] }, this.fetchFeed);
    }

    async fetchFeed() {
        try {
            const response = await UserService.fetchFollowing(null, 25);
            const following = response?.data?.following;

            if (!following || following.length === 0) {
                this.setState({ posts: [], isLoading: false });
                return;
            }

            const results = await Promise.all(
                following.map(user =>
                    PostService.fetchPostsForUserName(user.publicName, null, 25)
                        .then(r => r?.data?.posts || [])
                        .catch(() => [])
                )
            );

            const merged = results
                .flat()
                .sort((a, b) => b.dateCreated - a.dateCreated);

            this.setState({ posts: merged, isLoading: false });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    isAuthenticated() {
        return !!this.props.currentUser;
    }

    renderNavigation() {
        return <Navigation isAuthenticated={this.isAuthenticated()} currentUser={this.props.currentUser} navigation={this.props.navigation} />;
    }

    renderResponsiveNavigation() {
        return <ResponsiveNavigation isAuthenticated={this.isAuthenticated()} currentUser={this.props.currentUser} navigation={this.props.navigation} />;
    }

    renderEmpty() {
        return <div className="feed-empty">
            <p>No posts yet. Follow some creators to see their posts here.</p>
        </div>;
    }

    renderContent() {
        return <section className="featured">
            <h3 className="feed-heading">Your Feed</h3>
            <div className="container posts" id="container">
                {this.state.posts.length === 0
                    ? this.renderEmpty()
                    : <div className="row posts-row">
                        <PostList
                            posts={this.state.posts}
                            navigation={this.props.navigation}
                            loadMore={() => {}}
                            isAuthenticated={true}
                            currentUser={this.props.currentUser}
                        />
                    </div>
                }
            </div>
        </section>;
    }

    render() {
        return <div>
            <header>
                <div className="nav-container">
                    <div className="container">
                        {this.renderNavigation()}
                    </div>
                </div>
            </header>

            {this.state.isLoading ? <LoadingIndicator /> : this.renderContent()}

            <Footer />
            {this.renderResponsiveNavigation()}
            <HelmetComponent title='Feed' description='Posts from creators you follow on OpenSwap.' />
        </div>;
    }
}

export default Feed;
